import {booleanComponent, createColumn, defaultColumns, inputTextField, relationField} from '../_defaults/columns'

export const columns = [
  createColumn({
    label: 'Full Name',
    field: 'fullName',
    noSave: true,
    displayValue: row => {
      let returnVal = ''
      if (row.firstName && row.firstName.trim()) {
        returnVal = row.firstName.trim()
      }
      if (row.lastName && row.lastName.trim()) {
        returnVal = returnVal + ' ' + row.lastName.trim()
      }
      return returnVal
    },
    component: null,
    visible: false,
    filterable: false,
    sortable: false
  }),
  createColumn({
    label: 'Contact Info',
    field: 'contactInfo',
    noSave: true,
    displayValue: row => {
      let returnVal = ''
      if (row.emailAddress && row.emailAddress.trim()) {
        returnVal = row.emailAddress.trim() + ' '
      }
      if (row.homeNumber && row.homeNumber.trim()) {
        returnVal = returnVal + ' H: ' + row.homeNumber.trim()
      }
      if (row.cellNumber && row.cellNumber.trim()) {
        returnVal = returnVal + ' C: ' + row.cellNumber.trim()
      }
      if (row.workNumber && row.workNumber.trim()) {
        returnVal = returnVal + ' W: ' + row.workNumber.trim()
      }
      return returnVal
    },
    component: null,
    visible: false,
    filterable: false,
    sortable: false
  }),
  createColumn({
    label: 'First Name',
    field: 'firstName',
    // section: 'Basics',
    component: inputTextField({ req: true, max: 255 })
  }),
  createColumn({
    label: 'Middle Name',
    field: 'middleName',
    // section: 'Basics',
    visible: false,
    component: null
  }),
  createColumn({
    label: 'Last Name',
    field: 'lastName',
    // section: 'Basics',
    component: inputTextField({ req: true, max: 255 })
  }),
  createColumn({
    label: 'Suffix',
    field: 'suffix',
    visible: false,
    // section: 'Basics',
    component: null
  }),
  createColumn({
    label: 'Old Title',
    field: 'title',
    // section: 'Basics',
    visible: false,
    searchable: false,
    sortable: false,
    filterable: false,
    component: null
  }),
  createColumn({
    label: 'Title',
    field: 'profession',
    // section: 'Basics',
    description: 'Professional title, such as CEO, President, etc',
    component: inputTextField({ req: false, max: 255 })
  }),
  createColumn({
    label: 'Guest',
    field: 'guestData',
    type: 'boolean',
    // section: 'Basics',
    defaultValue: null,
    visible: false,
    searchable: false,
    sortable: false,
    filterable: false,
    component: booleanComponent,
    description: 'This person does not show in normal searches. The record was generated from event registration, donation, or purchase.'
  }),
  createColumn({
    label: 'Company',
    field: 'company',
    // section: 'Basics',
    ...relationField({
      validation: { required: false },
      type: 'one',
      localKey: 'companyId',
      fk: 'id',
      namespace: 'company',
      filterIs: 'text-filter',
      label: 'name'
    })
  }),
  createColumn({
    // FAKE FIELD
    label: 'Company is Member',
    field: 'isActive',
    noSave: true,
    formDisplay: false,
    // section: 'Basics',
    displayValue: obj => {
      if (obj && obj.membership && obj.membership.isActive) {
        return 'Yes'
      } else {
        return 'No'
      }
    },
    ...relationField({
      type: 'one',
      namespace: 'membership',
      localKey: 'id',
      fk: 'membershipId',
      directSearch: 'Company/Membership/isActive',
      fieldType: 'boolean',
      is: 'q-select',
      filterIs: 'select-filter',
      label: 'isActive',
      props: {
        options: [
          {
            label: 'Yes',
            value: 1
          },
          {
            label: 'No',
            value: 0
          }
        ]
      }
    })
  }),
  createColumn({
    // FAKE FIELD
    label: 'Membership Type',
    field: 'membershipType',
    formDisplay: false,
    noSave: true,
    displayValue: obj => {
      if (obj && obj.membership && obj.membership.membershipType && obj.membership.membershipType) {
        return obj.membership.membershipType.description
      } else {
        return ''
      }
    },
    ...relationField({
      type: 'one',
      namespace: 'membership',
      localKey: 'id',
      fk: 'membershipId',
      fieldType: 'number',
      directSearch: 'Company/Membership/membershipTypeId',
      label: 'description',
      filterIs: 'select-filter',
      props: {
        showBrowse: false,
        options: [
          {
            label: 'Specialty Contractor',
            value: 1
          },
          {
            label: 'General Contractor',
            value: 2
          },
          {
            label: 'Affiliate',
            value: 3
          }
        ]
      }
    })
  }),
  createColumn({
    // FAKE FIELD
    label: 'Division',
    field: 'companyDivision',
    formDisplay: false,
    noSave: true,
    displayValue: (val, row) => {
      if (row && row.company && row.company.companyDivision) {
        let output = ''
        for (const companyDivision of row.company.companyDivision) {
          output += '<span class="column"><span class="text-primary">' + companyDivision.division.name + '</span></span>'
        }
        return output
      }
    },
    ...relationField({
      type: 'many',
      linkTable: true,
      fk: 'company',
      localKey: 'id',
      namespace: 'division',
      label: 'name',
      filterIs: 'select-many-field',
      directSearch: 'Company/CompanyDivision/any(a:a/divisionId',
      fieldType: 'number',
      parentRestraint: true,
      props: { allowEdit: false }
    })
  }),
  createColumn({
    label: 'User Login Credentials',
    section: 'Credentials',
    field: 'aspnetuser',
    filterable: false,
    sortable: false,
    visible: false,
    relation: {
      type: 'one',
      label: 'email',
      namespace: 'self',
      localKey: 'aspnetuserId',
      filterIs: 'text-filter',
      fk: 'id'
    },
    component: {
      is: 'credentials-modal'
    }
  }),
  createColumn({
    label: 'User',
    field: 'userName',
    section: 'Credentials',
    noSave: true,
    formDisplay: false,
    visible: false,
    ...relationField({
      validation: { required: false },
      type: 'one',
      localKey: 'aspnetuserId',
      fk: 'id',
      namespace: 'aspnetuser',
      filterIs: 'text-filter',
      label: 'userName'
    })
  }),
  createColumn({
    label: 'Primary Email',
    field: 'emailAddress',
    section: 'Contact',
    component: inputTextField({ req: true, type: 'email', max: 255 })
  }),
  createColumn({
    label: 'Secondary Email',
    field: 'secondaryEmailAddress',
    section: 'Contact',
    visible: false,
    component: inputTextField({ type: 'email', max: 255 })
  }),
  createColumn({
    // TODO: REMOVE?  I Doubt we will track this.
    label: 'Email Bounced',
    field: 'emailBounced',
    section: 'Contact',
    visible: false,
    component: null
  }),
  createColumn({
    // TODO: Do persons really need this?
    label: 'Profile URL',
    field: 'profileUrl',
    section: 'Contact',
    visible: false,
    component: null
  }),
  createColumn({
    // TODO: Do persons really need this?
    label: 'Website URL',
    field: 'url',
    section: 'Contact',
    visible: false,
    component: null
  }),
  createColumn({
    label: 'Old Phone Number',
    field: 'homeNumber',
    section: 'Contact',
    visible: false,
    component: null
  }),
  createColumn({
    label: 'Phone Number',
    field: 'workNumber',
    section: 'Contact',
    component: inputTextField({ max: 255, type: 'tel' })
  }),
  createColumn({
    label: 'Cell Number',
    field: 'cellNumber',
    section: 'Contact',
    component: inputTextField({ max: 255, type: 'tel' })
  }),
  createColumn({
    label: 'Address',
    field: 'address',
    section: 'Contact',
    visible: false,
    sortable: false,
    ...relationField({
      props: {
        config: {
          params: {}
        }
      },
      validation: { required: false },
      type: 'one',
      localKey: 'addressId',
      fk: 'id',
      namespace: 'address',
      filterIs: 'text-filter',
      label: 'line1'
    })
  }),
  createColumn({
    label: 'Spouse Name',
    field: 'spouseName',
    section: 'Extended Info',
    visible: false,
    component: inputTextField({ req: false, max: 255 })
  }),
  createColumn({
    label: 'Gender',
    field: 'gender',
    section: 'Extended Info',
    visible: false,
    component: {
      is: 'q-select',
      filterIs: 'select-filter',
      props: {
        options: [
          {
            label: 'Male',
            value: 'M'
          },
          {
            label: 'Female',
            value: 'F'
          }
        ]
      }
    }
  }),
  createColumn({
    label: 'Constant Contact ID',
    field: 'ccId',
    section: 'Extended Info',
    visible: false,
    component: null
  }),
  createColumn({
    label: 'Graduated',
    field: 'graduated',
    section: 'Extended Info',
    visible: false,
    type: 'boolean',
    component: null
  }),
  createColumn({
    label: 'Graduated Year',
    field: 'graduatedYear',
    section: 'Extended Info',
    type: 'number',
    visible: false,
    defaultValue: null,
    clearValue: null,
    component: null
  }),
  createColumn({
    label: 'Comments',
    visible: false,
    field: 'comments',
    section: 'Extended Info',
    component: inputTextField({ type: 'textarea', req: false, max: 8192 })
  }),
  createColumn({
    label: 'Quickbooks Customer ID',
    field: 'qbCustomerId',
    section: 'Extended Info',
    visible: false,
    component: inputTextField({ req: false, max: 255 })
  }),
  createColumn({
    label: 'Committees',
    field: 'personCommittee',
    section: 'Extended Info',
    ...relationField({
      type: 'many',
      linkTable: true,
      fk: 'id',
      localKey: 'personId',
      namespace: 'committee',
      filterIs: 'select-many-field',
      label: 'name',
      props: { allowEdit: false }
    })
  }),
  createColumn({
    label: 'Groups',
    field: 'personGrouping',
    section: 'Extended Info',
    ...relationField({
      type: 'many',
      linkTable: true,
      fk: 'id',
      localKey: 'personId',
      namespace: 'grouping',
      filterIs: 'select-many-field',
      label: 'description',
      props: { allowEdit: false }
    })
  }),
  createColumn({
    label: 'Do Not Share My Info',
    field: 'doNotShare',
    visible: false,
    section: 'Event Preferences',
    type: 'boolean',
    component: booleanComponent
  }),
  createColumn({
    label: 'Diet Comment',
    field: 'dietComment',
    section: 'Event Preferences',
    visible: false,
    component: inputTextField({ type: 'textarea', max: 8192 })
  }),
  createColumn({
    label: 'Diet Options',
    field: 'personDietOption',
    section: 'Event Preferences',
    visible: false,
    ...relationField({
      type: 'many',
      linkTable: true,
      fk: 'id',
      localKey: 'person',
      namespace: 'dietOption',
      filterIs: 'select-many-field',
      label: 'description',
      props: { allowEdit: false }
    })
  }),
  createColumn({
    label: 'ADA Accessibility Assistance Needed',
    field: 'adaRequired',
    type: 'boolean',
    visible: false,
    section: 'Event Preferences',
    component: booleanComponent,
    defaultValue: false
  }),
  createColumn({
    label: 'Explanation of ADA Assistance Needed',
    field: 'adaComment',
    visible: false,
    section: 'Event Preferences',
    component: inputTextField({ type: 'textarea', max: 8192 })
  }),
  createColumn({
    label: 'Toolbox Expiration',
    field: 'toolboxExpiration',
    section: 'Extended Info',
    type: 'date',
    component: {
      is: 'q-datetime',
      props: {
        type: 'datetime',
        format24h: false,
        format: 'MMM DD YYYY h:mm a',
        clearable: true,
        options: [
          {
            label: 'Has Expiration',
            value: 'ne null'
          },
          {
            label: 'No Expiration',
            value: 'eq null'
          }
        ]
      },
      validation: {
        required: false
      },
      filterIs: 'select-filter',
      filterCustom: true
    }
  }),
  createColumn({
    label: 'GUID',
    field: 'guidId',
    type: 'text',
    section: 'Data Info',
    filterable: false,
    visible: false,
    searchable: false,
    holdFromEdit: true,
    component: null
  }),
  createColumn({
    label: 'Approved',
    field: 'approved',
    type: 'boolean',
    section: 'Status',
    visible: false,
    defaultValue: true,
    component: null
  }),
  createColumn({
    label: 'Date Approved',
    field: 'dateApproved',
    type: 'date',
    section: 'Status',
    visible: false,
    component: null
  }),
  createColumn({
    label: 'Updated',
    field: 'updatedAt',
    visible: false,
    searchable: false,
    type: 'date',
    sortable: true,
    component: null
  }),
  createColumn({
    label: 'New Record',
    field: 'isNew',
    type: 'boolean',
    section: 'Status',
    visible: false,
    defaultValue: false,
    component: null
  }),
  createColumn({
    label: 'Created',
    field: 'createdAt',
    visible: false,
    searchable: false,
    type: 'date',
    sortable: true,
    component: null
  })
].concat(defaultColumns)
